
import moment from 'moment';
import MainButton from '@/core/components/MainButton.vue';
import TabSelection from '@/core/components/TabSelection.vue';
import * as TelliqService from '@/services/telliq.service';
import { Booking, Machine } from '@/models/bookings';
import BookingItem from '../components/BookingItem.vue';
import Spinner from '@/core/components/Spinner.vue';
import FadeLoader from 'vue-spinner/src/FadeLoader.vue';
import { emitter } from '@/utils/constants';
import { GETTERS } from '@/store/getters';
import { MUTATIONS } from '@/store/mutations';
import { User } from '@/models/users';
import CommonMixin from '@/core/pages/CommonMixin';

export default CommonMixin.extend({
  data() {
    return {
      loading: false,
      loading_bookings: false,
      partial_responses: {
        active: true,
        completed: true,
      },
      tab_active: 0,
      tab_names: [this.$t('bookings.labels.bookings'), this.$t('bookings.labels.completed')],
      active_bookings: [] as Booking[],
      completed_bookings: [] as Booking[],
      machines: [] as Machine[],
      booking_start_date_picker: false,
      booking_end_date_picker: false,
      bookings_start_date: moment().subtract(7, 'days').format('YYYY-MM-DD'),
      bookings_end_date: moment().add(7, 'days').format('YYYY-MM-DD'),
    };
  },

  components: {
    MainButton,
    TabSelection,
    BookingItem,
    Spinner,
    FadeLoader,
  },

  async created() {
    await this.checkLogoutFromMs();

    const user: User = this.$store.getters[GETTERS.GET_USER];
    this.$store.commit(MUTATIONS.SET_HEADER, { title: 'Poolcar', subtitle: user.login });
    this.resetBookingstate();

    this.loading = true;
    await this.loadBookings();
    this.loading = false;
  },

  methods: {
    async checkLogoutFromMs(): Promise<void> {
      if (this.$store.getters[GETTERS.GET_IS_LOGOUT_FROM_MS]) {
        this.$store.commit(MUTATIONS.CLEAR_STATE);
        this.$router.push('/login');
      }
    },

    async loadBookings(): Promise<void> {
      if (this.$store.getters[GETTERS.GET_IS_AUTHENTICATED]) {
        this.loading_bookings = true;
        try {
          const bookings = await TelliqService.getBookings(
            moment(this.bookings_start_date).startOf('day').utcOffset(0, true).toISOString(),
            moment(this.bookings_end_date).endOf('day').utcOffset(0, true).toISOString(),
          );

          const user = this.$store.state.user as User;
          const user_bookings = bookings.filter((booking) => booking.driverId === user.id);

          const today = moment();
          const new_active_bookings = user_bookings.filter((booking) => today.isSameOrBefore(booking.endDate));
          const new_completed_bookings = user_bookings.filter((booking) => today.isAfter(booking.endDate));

          this.active_bookings = new_active_bookings.reverse();
          this.completed_bookings = new_completed_bookings;
        } catch (e) {
          emitter.emit('notify', {
            text: this.$t('core.errors.something_went_wrong'),
            color: 'error',
          });
        }
        this.loading_bookings = false;
      }
    },

    resetBookingstate(): void {
      this.$store.commit(MUTATIONS.CLEAR_BOOKING_STATE);
    },

    startBooking(): void {
      this.$store.commit(MUTATIONS.CLEAR_CREATE_BOOKING);
      this.$store.commit(MUTATIONS.SET_EDIT_BOOKING, '');
      this.$store.commit(MUTATIONS.SET_BOOKING_URL, this.$route.path);
      this.$router.push('/booking/start-date');
    },

    onTabChanged(tab_index: number): void {
      this.tab_active = tab_index;
    },

    removeBooking(booking_id: number): void {
      if (this.active_bookings.find((booking) => booking.id === booking_id)) {
        this.active_bookings.splice(
          this.active_bookings.findIndex((booking) => booking.id === booking_id),
          1,
        );
      }
    },
  },

  computed: {
    datePickerBookingStartDate(): string {
      return moment(this.bookings_start_date).format('DD-MM-YYYY');
    },

    datePickerBookingEndDate(): string {
      return moment(this.bookings_end_date).format('DD-MM-YYYY');
    },
  },
});
